import React, { useState, useContext, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { Button, Layout, Toast, Icon } from "@app/components";
import { getLabelsOnly, teacherPlan, useLocation } from "@app/utils";
import { AuthContext } from "@app/providers";
import { submitContent } from "@app/services";
import {
  ButtonContainer,
  SuccessContainer,
  SuccessHeading,
  SuccessText,
} from "../educator-component";
import WizardComponent from "./wizard";
import SubmitContentComponent from "./content";
import { ContentHolder } from '../../../components/commonStyles/common-components'
import { PopUpContainer, PopUpSubTitle, PopUpTitle, PopUpWrapper } from "@app/components/success-modal/success-modal-components";

export default function EducatorAccountSetup() {
  const { handleSubmit, register, errors, control, trigger }: any = useForm({
    shouldUnregister: false,
    defaultValues: {
      typeOfPlan: "lessonPlan",
    },
  });
  const { userInfo, setUserInfo } = useContext(AuthContext);
  const { navigate } = useLocation();
  const [selectedWizard, setSelectedWizard] = useState<number>(1);
  const [content, setContent] = useState<any>();
  const [addInfo, setAddInfo] = useState<any>();
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [buttonText, setButtonText] = useState<string>("Continue");
  const [planType, setPlanType] = useState<string>("lessonPlan");
  const [showToast, setShowToast] = useState(false);
  const [formSubmit, showFormSubmit] = useState(false)
  const userToken = userInfo && userInfo.sessionToken;
  // const scrollToRef = (ref:any) => window.scrollTo(0, ref.current.offsetTop) 
  // const myRef = useRef(null)
  //  const executeScroll = () => scrollToRef(myRef)
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  let scrollRef: any = React.useRef(null);


  useEffect(() => {
    if (userToken && (userInfo.userJson.userType === "student" || userInfo.userJson.userType === "parent")) {
      navigate('/pagenotfound')
    }
  }, []);

  async function validateForm() {
    const result = await trigger();
    return result;
  }

  function updateWizard(e: number, setactive: boolean) {
    if (e === selectedWizard || e > 3) return;
    if (setactive) {
      if (e > selectedWizard) {
        validateForm().then((res: any) => {
          if (res) {
            setSelectedWizard(e);
          }
        });
      } else {
        setSelectedWizard(e);
      }
    } else {
      setSelectedWizard(e);
    }
  }
  const onSubmit = (data: any) => {
    // executeScroll()
    // window.scroll(0,10)
    // let page = document.getElementsByTagName(ContentHolder)
    if (selectedWizard === 1) {
      setContent(data);
      setSelectedWizard(selectedWizard + 1);
    } else if (selectedWizard === 2) {
      window.scrollTo(0, 0)
      setAddInfo(data);
      setSelectedWizard(selectedWizard + 1);
      setButtonText("Submit");
    } else {
      setButtonText("Submitting...");
      const params: any = {};
      const teachingGrades = getLabelsOnly(content.teachingGrades);
      const subjectExpertise = getLabelsOnly(content.subjectExpertise);
      const submissionGrades = getLabelsOnly(data.submissionGrades);
      const plan: any = teacherPlan.find(
        (plan) => plan.value === data.typeOfPlan
      );
      Object.assign(params, {
        userId: userInfo.userJson.userId,
        sessionToken: userInfo.sessionToken,
        education: content.education.label,
        teachingGrades: teachingGrades,
        qualification: content.qualification,
        awards: content.awards,
        subjectExpertise: subjectExpertise,
        teachingStyle: addInfo.teachingStyle,
        educationalPhilosophy: addInfo.educationalPhilosophy,
        favoriteSubject: addInfo.favoriteSubject,
        makesLessionSuccessful: addInfo.makesLessionSuccessful,
        engageStudentsInLession: addInfo.engageStudentsInLession,
        typeOfPlan: plan.label,
        submissionSubject: data.submissionSubject.label,
        submissionTopic: data.submissionTopic,
        submissionGrades: submissionGrades,
        essentialQuestions: data.essentialQuestions,
        lessionObjective: data.lessionObjective,
        keySkills: data.keySkills,
        submissionStandards: data.submissionStandards,
        lessionDescription: data.lessionDescription,
        makeThisSpecial: data.makeThisSpecial,
      });
      submitContent(params)
        .then((res: any) => {
          let response: any = res;
          if (response._responseStatus === 1) {
            setButtonText("Submit");
            // setShowSuccess(true);
            showFormSubmit(true)
          } else if (response.msgCode === "SSN_002") {
            setShowToast(true);
            setToastMessage({
              type: "error",
              message: response.msg,
            });

            setTimeout(() => {
              localStorage.clear();
              setUserInfo(null);
              navigate("/sign-in");
            }, 5000);
          } else {
            setButtonText("Submit");
            setShowToast(true);
            setToastMessage({
              type: "error",
              message: response.msg,
            });
          }
        })
        .catch((err) => {
          setButtonText("Submit");
          console.log(err);
          setShowToast(true);
          setToastMessage({
            type: "error",
            message: `something went wrong, Please try again`,
          });
        });
    }
  };
  function onChange(data: any) {
    if (data.target.name === "typeOfPlan") {
      setPlanType(data.target.value);
    }
  }

  useEffect(() => {
    if (scrollRef && scrollRef.current) {
      scrollRef.current.scrollTo(0, 0);
    }
  }, [selectedWizard]);

  // function ScroolToTop(){
  //   // document.getElementsByClassName("body").style.overflowY = "hidden"
  //   // document.getElementsByTagName("body")
  //   document.body.scrollTop = 0;
  //   document.documentElement.scrollTop = 0;

  // }

  if (!showSuccess) {
    return (
      <>
        <Layout ref={scrollRef} >
          <h3 className="primary-header text-center mb-3">
            Educator Account Setup
        </h3>
          <WizardComponent
            updateWizard={updateWizard}
            selectedWizard={selectedWizard}
            content={content}
            addInfo={addInfo}
          />
          {/* <div ref={scrollRef}> */}
          <form onSubmit={handleSubmit(onSubmit)} onChange={onChange}>
            <SubmitContentComponent
              errors={errors}
              control={control}
              register={register}
              selectedWizard={selectedWizard}
              planType={planType}
            />
            <ButtonContainer disabled={buttonText === "Submitting..."}>
              <Button variant="newsecondary" width={"100%"} type="submit" >
                {buttonText}
              </Button>
            </ButtonContainer>
            <Button
              variant="bordered"
              width={"100%"}
              type="button"
              onClick={() => navigate("/educator")}
            >
              Cancel
          </Button>
          </form>
          {/* </div> */}
          <Toast
            message={toastMessage.message}
            showToast={showToast}
            type={toastMessage.type}
            onClose={() => setShowToast(false)}
          />
        </Layout>
        {formSubmit && <PopUpWrapper>
          <PopUpContainer>
            <Icon name="signsuccess" />
            <span className="close-icon" onClick={() => navigate("/educator")}>
              <Icon name="close" />
            </span>
            <PopUpTitle>Form Submission Completed</PopUpTitle>
            <PopUpSubTitle className="mb-2">Your form has been submitted successfully. Our team will review your form and will get back to you shortly. You can Submit Content and Monetize anytime from now.</PopUpSubTitle>
            <Button
              variant="newsecondary"
              type="button"
              onClick={() => navigate("/educator")}
            >
              Okay!
          </Button>
          </PopUpContainer>
        </PopUpWrapper>}
      </>
    );
  } else {
    return (
      <Layout className="aligned-center">
        <SuccessContainer>
          <Icon name="signsuccess" />
          <SuccessHeading>
            Form Submission Completed
          </SuccessHeading>
          <SuccessText>
            Your form has been submitted successfully. Our team will review your form and will get back to you shortly.<br />You can Submit Content and Monetize anytime from now.
          </SuccessText>
          <Button
            variant="newsecondary"
            type="button"
            onClick={() => navigate("/educator")}
          >
            Okay!
          </Button>
        </SuccessContainer>
      </Layout>
    );
  }
}
